export default __webpack_public_path__ + "images/773b5241e7be0ef600ce420836bed98c-screening.jpg";